import React, { useEffect, useState } from 'react';
import logo from '../assets/logo.png';
import "./foodcard.css";
require.context('../assets', false, /\.(png|jpe?g|svg)$/);

const Foodcard = ({item,onClick}) => {
  const [food,setFood] = useState({});  
  useEffect(() => {
    setFood(item);
  },[]);


  const getOptimizedUrl = (url, size = 'small') => {
    if (!url || !url.includes('cloudinary.com')) return url;
    const settings = 'w_500,f_auto,q_30';
    return url.replace('/upload/', `/upload/${settings}/`);
  };

  return (
    
      <div className="card" onClick={onClick}>
        <div className="row">
          <img  className="image-food px-2 py-1 d-block" src={food.image !== null ? getOptimizedUrl(food.image) : logo} alt=""/>
        </div>
        <div className="row">
          <div className="card-block  pt-1">
            <p className='title'>{food.name ? food.name : "Food"}</p>
          </div>
        </div>
        <div className="pt-1 row p-0 pe-2">
        <p className='price'>{food.price ? food.price : "100"}{" ₺"}</p>
        </div>
    </div>
  )
}

export default Foodcard;